<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" scrollable max-width="540px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Upload New Patient List</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="dialogLocal = false">Cancel</v-btn>
                </v-card-actions>
                <v-progress-linear v-if="waiting" :indeterminate="true"/>
                <v-card-text>
                    <form enctype="multipart/form-data" novalidate v-if="!waiting">
                        <div class="dropbox">
                            <input type="file" id="file" ref="file" @change="save()" accept=".csv" class="input-file"/>
                            <p v-if="!waiting">
                                Drag your patient CSV file here to begin<br> or click to browse.
                            </p>
                        </div>
                    </form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex';

    export default
    {
        name: 'patient-batch-data-dialog',
        data: function ()
        {
            return {
                dialogLocal: false,
                showSuccess: null
            }
        },
        props:
        {
            dialog: Boolean(false)
        },
        computed:
        {
            ...mapState('tests',
            {
                patientFileUrl: state => state.patientFileUrl
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        watch:
        {
            dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.$emit('dialog-close', this.showSuccess)
                }
                else // Else the dialog is being opened
                {
                    this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                    {
                        app_name: 'Web Portal',
                        screen_name: `Reflex Web Portal - ${this.$options.name}`,
                        app_version: process.env.VUE_APP_VERSION
                    });
                    this.dialogLocal = val;
                    this.showSuccess = null
                }
            },
            dialog(val)
            {
                this.dialogLocal = val
            }
        },
        methods:
        {
            ...mapActions('tests', ['GET_PATIENT_FILE_URL', 'UPLOAD_PATIENT_FILE']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_WARN_DELAY', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async save()
            {
                try
                {
                    const file = this.$refs.file.files[0];
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_PATIENT_FILE_URL();
                    await this.UPLOAD_PATIENT_FILE({url: this.patientFileUrl, file: file});
                    this.showSuccess = true;
                    this.dialogLocal = false
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_WARN_DELAY({message: error.message, delay: 10000})
                }
                this.WAITING(false)
            }
        }
    };
</script>

<style scoped lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}
</style>